module.exports = __webpack_public_path__ + "static/livechat-live-coding-4-og-7fadc35ee84c24d9f44a663a50dad36f.png";